import { Controller } from "@hotwired/stimulus"
import { createApp } from 'vue/dist/vue.esm-bundler.js'

import { formDependenciesPlugin } from '../../../frontend/dependencies/formDependencies'

import CalendarPopover from "../../../frontend/components/CalendarPopover.vue"
import MorePopover from '../../../frontend/components/MorePopover.vue'
import PrimeVue from 'primevue/config'

import DateTimePicker from "../../../frontend/components/DateTimePicker.vue"
import DateTimeRangePicker from "../../../frontend/components/DateTimeRangePicker.vue"
import InlineHelp from "../../../frontend/components/InlineHelp.vue"
import Multiselect from "../../../frontend/components/Multiselect.vue"
import { i18n } from '../../../frontend/entrypoints/i18n'

import Tabs from 'primevue/tabs'
import TabList from 'primevue/tablist'
import Tab from 'primevue/tab'
import TabPanels from 'primevue/tabpanels'
import TabPanel from 'primevue/tabpanel'

export default class extends Controller {
  // Connected when update_page.js.erb is called
  connect() {
    console.log('Mounting page container')
    this.pageApp = createApp()

    this.pageApp
      .component('datetimepicker', DateTimePicker)
      .component('datetimerangepicker', DateTimeRangePicker)
      .component('tabs', Tabs)
      .component('tablist', TabList)
      .component('tab', Tab)
      .component('tabpanels', TabPanels)
      .component('tabpanel', TabPanel)
      .component('inlinehelp', InlineHelp)
      .component('multiselect', Multiselect)
      .component('morepopover', MorePopover)
      .component('calendarpopover', CalendarPopover)

    this.pageApp.use(PrimeVue, { unstyled: true })
    this.pageApp.use(i18n)
    this.pageApp.use(formDependenciesPlugin)

    this.pageApp.mount('#page-container')
  }

  disconnect() {
    this.pageApp.unmount()
  }
}
